import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Api from "../../Redux/common/api";
import { toast } from "react-toastify";
import { URL } from "../../Redux/common/url";

function Register2() {
  const [userData, setuserData] = useState({});
  console.log(userData);
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const ref = searchParams.get("ref");
  const club = searchParams.get("club");
  const searchData = searchParams.get("search");

  const [referName, setreferName] = useState("");
  const [referID, setreferID] = useState("");
  console.log(referName);
  useEffect(() => {
    if (ref) {
      hendlereferCheck(ref);
    }

    return () => {};
  }, [location.search]);
  const hendlereferCheck = async (e) => {
    setreferID(e);
    try {
      // let uppercaseStr = loginData?.phone.toUpperCase();
      const response = await Api.post(`${URL.referCheck}`, {
        referBy: e?.toUpperCase(),
      });

      console.log(response);

      if (response?.data?.success) {
        setreferName(response?.data?.data?.fullName);
      } else {
        setreferName("");
        // toast.error("invalid refer code");
      }
    } catch (error) {
      console.log(error);
      toast.error("invalid Referral code");
    }
  };

  const onChange = (e) => {
    setuserData({ ...userData, [e.target.name]: e.target.value });
  };


  
  const [otpBox, setotpBox] = useState("0");
  const [otpBox1, setotpBox1] = useState("0");

  const onSubmitOtp = async (e) => {
    e.preventDefault();
    try {
      if (!userData?.otp) {
        toast?.error("please enter otp");
        return;
      }

      if (userData?.otp?.length !== 6) {
        toast?.error("please enter valid otp");
        return;
      }

      const response = await Api.post(`${URL.emailotpVerifyuser}`, userData);

      if (response?.data?.success) {
        toast?.success(response?.data?.message);
        navigate("/login");
      } else {
        console.log("error:");
        // Login failed
        // setError(data.message || "Login failed");
      }
    } catch (error) {}
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!userData?.fullName) {
      toast.error("Full Name Required");
    } else if (!userData?.phone) {
      toast.error("please enter phone");
    } else if (userData?.phone?.length !== 10) {
      toast.error("invalid phone number");
    } else if (!userData?.email) {
      toast.error("Email Required");
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(userData?.email)
    ) {
      toast.error("Email  Invalid");
    } else if (!userData?.confirmPassword) {
      toast.error("Confirm Password Required");
    } else if (!userData?.password) {
      toast.error("Password Required");
    } else if (userData?.password !== userData?.confirmPassword) {
      toast.error("Password not Match");
    } else if (!referName) {
      toast.error("please enter referral code");
    } else {
      console.log(userData);

      try {

        userData.referBy = referID;
        userData.role_name= "User"
        const response = await Api.post(`${URL.otpVerifyuser}`, userData);
        // const response = await fetch("http://localhost:3022/public/register", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json", // Server ko batata hai data JSON format me hai
        //   },
        //   body: JSON.stringify(userData), // Body me data send karte hain
        // });

        // const data = await response.json(); // Response ko JSON me convert kare

        if (response?.data?.success) {
          // Login successful
          // setSuccess("Login successful!");
          // alert("Registered Successfully");
           toast.success(response?.data?.message);
                    navigate("/login");
                    // setotpBox("1");
          // console.log("User data:", data);
        } else {
          console.log("error:");
          // Login failed
          // setError(data.message || "Login failed");
        }
      } catch (err) {
        // setError("Something went wrong. Please try again.");
      }
    }
  };
  return (
    <div className="">
      <div class="container d-flex justify-content-center align-items-center vh-100">
        <div
          class="signup-container border p-4 rounded shadow-sm bg-white"
          style={{ maxWidth: "400px", width: "100%" }}
        >
          <h4
            class="text-center text-white py-2 rounded"
            style={{ background: "linear-gradient(90deg, #6a11cb, #2575fc)" }}
          >
              Gateway Landmark Group
          </h4>


          {otpBox == "0" ? (
          <form>
            <div class="mb-3">
              <label class="form-label">Full Name</label>
              <input
                type="text"
                name="fullName"
                class="form-control"
                placeholder="Please enter full name"
                required
                onChange={onChange}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Mobile No.</label>
              <div class="d-flex">
                {/* <select class="form-control w-25 me-2">
                  <option>Select</option>
                  <option>+91</option>
                  <option>+1</option>
                  <option>+44</option>
                </select> */}
                <input
                  type="number"
                  class="form-control"
                  placeholder="Enter Mobile No."
                  name="phone"
                  required
                  onChange={onChange}
                />
              </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Email</label>
              <input
                type="email"
                class="form-control"
                placeholder="Please enter your email"
                required
                name="email"
                onChange={onChange}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Please   your password"
                required
                name="password"
                onChange={onChange}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Confirm Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Please  enter confirm password"
                required
                name="confirmPassword"
                onChange={onChange}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Referal code</label>
              <input
                type="text"
                class="form-control"
                placeholder="Please  enter Referal code"
                required
                value={ref}
                // name="confirmPassword"
                // onChange={onChange}
                // onBlur={(e) => {
                //   hendlereferCheck(e?.target?.value);
                // }}
              />
            </div>

            <div class="mb-3">
              <label class="form-label">Referral Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="Please  enter Referral Name"
                required
                name="confirmPassword"
                value={referName}
                // onChange={onChange}
              />
            </div>
            {/* <div class="mb-3 d-flex">
              <input
                type="text"
                class="form-control"
                placeholder="Email verification code"
                required
              />
              <button
                type="button"
                class="btn btn-outline-success ms-2"
                disabled
              >
                Get
              </button>
            </div> */}
            {/* <div class="mb-3">
              <label class="form-label">Referral Code</label>
              <div class="p-2 bg-light border rounded">UEX715</div>
            </div> */}
            <button
              type="submit"
              class="btn btn-primary w-100"
              onClick={onSubmit}
            >
              Sign Up
            </button>
          </form>): (
            <form>
              {/* <div class="mb-3">
                <label class="form-label">Mobile No.</label>
                <div class="d-flex">
                  
                  <input
                    type="number"
                    class="form-control"
                    placeholder="Enter Mobile No."
                    name="phone"
                    required
                    onChange={onChange}
                  />
                </div>
              </div> */}
              <div class="mb-3">
                <label class="form-label">Email</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="Please enter your email"
                  required
                  name="email"
                  value={userData?.email}
                  // onChange={onChange}
                />
              </div>

              <div class="mb-3">
                <label class="form-label">Otp</label>
                <input
                  type="number"
                  name="otp"
                  class="form-control"
                  placeholder="Please enter otp"
                  required
                  value={userData?.otp}
                  onChange={onChange}
                />
              </div>
              {/* <div class="mb-3">
              <label class="form-label">Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Please   your password"
                required
                name="password"
                onChange={onChange}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Confirm Password</label>
              <input
                type="password"
                class="form-control"
                placeholder="Please  enter confirm password"
                required
                name="confirmPassword"
                onChange={onChange}
              />
            </div>
            <div class="mb-3">
              <label class="form-label">Referal code</label>
              <input
                type="text"
                class="form-control"
                placeholder="Please  enter Referal code"
                required
                // name="confirmPassword"
                // onChange={onChange}
                onBlur={(e) => {
                  hendlereferCheck(e?.target?.value);
                }}
              />
            </div> */}

              {/* <div class="mb-3">
              <label class="form-label">Referral Name</label>
              <input
                type="text"
                class="form-control"
                placeholder="Please  enter Referral Name"
                required
                name="confirmPassword"
                value={referName}
                // onChange={onChange}
              />
            </div> */}
              {/* <div class="mb-3 d-flex">
              <input
                type="text"
                class="form-control"
                placeholder="Email verification code"
                required
              />
              <button
                type="button"
                class="btn btn-outline-success ms-2"
                disabled
              >
                Get
              </button>
            </div> */}
              {/* <div class="mb-3">
              <label class="form-label">Referral Code</label>
              <div class="p-2 bg-light border rounded">UEX715</div>
            </div> */}

              <button
                type="submit"
                class="btn btn-primary w-100"
                onClick={onSubmitOtp}
              >
                Verify
              </button>
              <button
                type="submit"
                class="btn btn-primary w-100  mt-4"
                onClick={() => {
                  setotpBox("0");
                }}
              >
                Change Email
              </button>
            </form>
          )}
          <p class="text-center mt-3">
            Have an account? <Link to="/login">Log in</Link>
          </p>
        </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
  );
}

export default Register2;
